"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsonrpc = require("../jsonrpc");

/* eslint-disable */
var _default = async (_ref, res, next) => {
  let payload = _ref.payload,
      store = _ref.store;
  if (payload.method !== 'eth_accounts') return next();

  if (store.state.wallet) {
    res(null, (0, _jsonrpc.toPayload)(payload.id, [store.state.wallet.getAddressString()]));
  } else {
    try {
      store.state.enable().then(accounts => {
        res(null, (0, _jsonrpc.toPayload)(payload.id, accounts));
      });
    } catch (e) {
      res(null, (0, _jsonrpc.toPayload)(payload.id, []));
    }
  }
};

exports.default = _default;